






























































































































































import { Component, Vue } from "vue-property-decorator";
import api from "@/api";
import store from "@/store";
import {base64DownloadFile, ExportExcel} from "@/utils/exportFile";
@Component({})
export default class realtimeOrder extends Vue {
  // 表格数据
  tableData = [];
  // 加载状态
  loading = false;
  // 总条数
  total = 0;
  // 搜索条件
  search: any = {
    id: "",
    channelId: "",
    tradingCenterCode: "",
    created_at: [],
    pagination: {
      page: 0, //页码，从0开始
      pageSize: 20, //每页数量
    },
  };

  exportLoading = false
  exportD() {
    this.exportLoading = true
    api.post('J27791', this.search).then(res => {
      base64DownloadFile(res.fileName, res.fileBase64 )
    }).finally(() => {
      this.exportLoading = false
    })
  }


  //获取交易中心
  channelList: any = {};

  // 日志
  logDialog = false;
  logList = [];
  logTotal = 0;
  listLoading = false;

  lookLogDialog = false;
  cancleLog() {
    this.logDialog = false;
  }
  cancleLogLook() {
    this.lookLogDialog = false;
  }

  logSearch = {
    objectId: "",
    objectType: "order_manage",
    pagination: {
      page: 0, //页码，从0开始
      pageSize: 10, //每页数量
    },
  };
  logTable = [];
  toLog(row: any) {
    this.logSearch.objectId = row.id;
    api.post("J27756", { ...this.logSearch }).then((res) => {
      this.logDialog = true;
      this.logTable = res.list;
      this.logTotal = res.total;
    });
  }

  changeLog(page: any) {
    this.logSearch.pagination.page = page - 1;
    api.post("J27756", { ...this.logSearch }).then((res) => {
      // this.logDialog = true
      this.logTable = res.list;
      this.logTotal = res.total;
    });
  }

  row = {};
  logDetail = false;
  openDesc = false;
  handleCloseLogDialog() {
    this.logDialog = false;
  }
  toLogDetail(row: any) {
    this.logDetail = true;
    this.row = row;
  }
  CloseLogDetailDialog() {
    this.logDetail = false;
  }

  // 搜索 search:true 重置翻页
  searchTable(search = false) {
    this.loading = true;
    if (search) {
      this.search.pagination = {
        pageSize: 20,
        page: 0,
      };
    }
    api
      .post("J27754", {
        ...this.search,
        tradingCenterCode: this.search.tradingCenterCode,
      })
      .then((data) => {
        this.total = data.total;
        this.tableData = data.list;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  toDetail(row: any) {
    this.$router.push({
      path: "/shop/listDetail",
      query: {
        id: row.id,
      },
    });
  }

  config = {};
  getConfig() {
    api.getJavaConfig().then((res) => {
      this.config = res;
    });
  }

  kfConfig = []
  getkfList() {
      api.post('J27778').then(res => {
          this.kfConfig = res.list
      })
  }

  yqrConfig = []
  getYqrList() {
      api.post('J27779').then(res => {
          this.yqrConfig = res.list
      })
  }

  activated() {
    this.getConfig();
    this.getkfList()
    this.getYqrList()
    this.searchTable();
  }
}
